<template>
  <div v-if="participacionesPorClase && actividadesPorId">

    <div class="row mb-3 d-print-none">
      <b-dropdown id="dropdown-periodo" :text="'Periodo: ' + periodoTexto(periodoSeleccionado)">
        <b-dropdown-item v-for="periodo in curso.periodos" :key="periodo.id_periodo" @click="cambiarPeriodo(periodo.id_periodo)">{{ periodoTexto(periodo.id_periodo) }}</b-dropdown-item>
      </b-dropdown>
    </div>

    <template v-if="modelo == 1">
    <table class="table table-bordered" style="page-break-after: always" v-for="c in listaClases" :key="c">
      <thead>
        <tr>
          <th colspan="6" class="text-center">{{ participacionesPorClase[c].nombre }} ({{ periodoTexto(periodoSeleccionado) }})</th>
        </tr>
        <tr>
          <th>Alumno</th>
          <th>L</th>
          <th>M</th>
          <th>X</th>
          <th>J</th>
          <th>V</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="persona in participacionesPorClase[c].alumnos" :key="`${c}-${persona.id_persona}`">
          <td class="py-2">{{ persona.nombre }} {{ persona.apellidos }}</td>
          <td class="py-2"><template v-if="'1' in persona.participaciones">{{ actividadesPorId[persona.participaciones['1']].nombre }}</template></td>
          <td class="py-2"><template v-if="'2' in persona.participaciones">{{ actividadesPorId[persona.participaciones['2']].nombre }}</template></td>
          <td class="py-2"><template v-if="'3' in persona.participaciones">{{ actividadesPorId[persona.participaciones['3']].nombre }}</template></td>
          <td class="py-2"><template v-if="'4' in persona.participaciones">{{ actividadesPorId[persona.participaciones['4']].nombre }}</template></td>
          <td class="py-2"><template v-if="'5' in persona.participaciones">{{ actividadesPorId[persona.participaciones['5']].nombre }}</template></td>
        </tr>
      </tbody>
    </table>
    </template>

    <template v-else-if="modelo == 2">
    <span v-for="c in listaClases" :key="c">
    <h3 class="text-center mb-3" style="page-break-before: always">{{ participacionesPorClase[c].nombre }} ({{ periodoTexto(periodoSeleccionado) }})</h3>
    <table class="table table-bordered my-4" style="page-break-inside: avoid">
      <thead>
        <tr>
          <td class="text-center bg-light"><b>Lunes</b></td>
          <td class="text-center bg-light"><b>Martes</b></td>
          <td class="text-center bg-light"><b>Miércoles</b></td>
          <td class="text-center bg-light"><b>Jueves</b></td>
          <td class="text-center bg-light"><b>Viernes</b></td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="dia in Object.keys(participacionesPorClase[c].actividades)" :key="dia">
            <span v-for="id_actividad in Object.keys(participacionesPorClase[c].actividades[dia])" :key="id_actividad">
            <b>{{ actividadesPorId[id_actividad].nombre }}</b>
            <p>
            <span v-for="persona of participacionesPorClase[c].actividades[dia][id_actividad]" :key="`${c}-${id_actividad}-${persona.id_persona}`">
            {{ persona.nombre }} {{ persona.apellidos[0] }}<br />
            </span>
            </p>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    </span>
    </template>

  </div>
</template>

<script>

import { api } from '../api/api.js';
import { obtenerCursoActivo, obtenerPeriodoActual } from '../curso.js';
import * as utils from '../utils.js';

export default {
	name: 'AdminListadosClases',
	props: [
		'modelo',
		'id_periodo',
    ],
	data () {
		return {
			actividades: null,
			actividadesPorId: null,
			participaciones: null,
			participacionesPorClase: null,
			curso: null,
			listaClases: null,
			periodoSeleccionado: null,
		}
	},
	created () {
		this.curso = obtenerCursoActivo();
		this.obtenerActividades();
		let periodoInicial;
		if (this.id_periodo) {
			periodoInicial = this.id_periodo;
		} else {
			periodoInicial = obtenerPeriodoActual().id_periodo;
		}
        this.periodoSeleccionado = periodoInicial;
	},
	watch: {
		periodoSeleccionado: function(idPeriodo) {
			this.obtenerParticipaciones(idPeriodo);
		},
	},
	methods: {
		cambiarPeriodo(idPeriodo) {
			this.participacionesPorClase = null;
			this.$router.push(`/admin/niveles/clases${this.modelo}/${idPeriodo}`);
			this.periodoSeleccionado = idPeriodo;
		},
		obtenerActividades () {
			api(`/actividades/${this.curso.id_curso}`)
				.then((data) => {
					this.actividades = data.resultado;
					const actividadesPorId = {};
					for (const a of this.actividades) {
						actividadesPorId[a.id] = a;
					}
					this.actividadesPorId = actividadesPorId;
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		obtenerParticipaciones(idPeriodo) {
			api(`/actividades/${this.curso.id_curso}/participaciones/${idPeriodo}`)
				.then((data) => {
					this.participaciones = data.resultado;
					this.procesarParticipaciones();
				})
				.catch((error) => {
					console.log(error);
					//this.mensaje_error = error;
				});
		},
		procesarParticipaciones() {
			const participacionesPorClase = {};
			this.listaClases = [];
			for (const nivel of this.curso.niveles) {
				for (const clase of nivel.clases) {
					const nivelClase = `${nivel.id_nivel}-${clase}`;
					this.listaClases.push(nivelClase);
					participacionesPorClase[nivelClase] = {
						nombre: `${nivel.nombre} ${clase}`,
						alumnos: [],
						actividades: {
							'1': {},
							'2': {},
							'3': {},
							'4': {},
							'5': {},
						},
					}
				}
			}
			for (const datosPersona of this.participaciones) {
				// Sólo queremos los alumnos
				if (datosPersona.nivel.id_nivel > 9) {
					continue;
				}
				// Ignoramos a los que no tienen clase
				if (! datosPersona.nivel.clase) {
					continue;
				}
				const nivelClase = `${datosPersona.nivel.id_nivel}-${datosPersona.nivel.clase}`;
				const participacionesPersona = {};
				for (const part of datosPersona.participaciones) {
					if (! part.horas) {
						continue;
					}
					for (const h of part.horas) {
						const diaHoras = h.split('-');
						const dia = diaHoras[0];
						const horaInicio = diaHoras[1];

						// FIXME: esto debería ser configurable (p.ej para obtener listados de las 17:00), tal vez con un desplegable
						if (horaInicio == '1600') {
							participacionesPersona[dia] = part.id_actividad;
							if (! (part.id_actividad in participacionesPorClase[nivelClase].actividades[dia])) {
								participacionesPorClase[nivelClase].actividades[dia][part.id_actividad] = [];
							}
							participacionesPorClase[nivelClase].actividades[dia][part.id_actividad].push({
								id_persona: datosPersona.id_persona,
								nombre: datosPersona.nombre,
								apellidos: datosPersona.apellidos,
							});
						}
					}
				}
				participacionesPorClase[nivelClase].alumnos.push({
					id_persona: datosPersona.id_persona,
					nombre: datosPersona.nombre,
					apellidos: datosPersona.apellidos,
					participaciones: participacionesPersona,
				});
			}
			for (const nivelClase of this.listaClases) {
				participacionesPorClase[nivelClase].alumnos.sort((a, b) => { return (a.nombre < b.nombre) ? -1 : (a.nombre > b.nombre) ? 1 : 0; });
				for (const dia in participacionesPorClase[nivelClase].actividades) {
					for (const id_actividad in participacionesPorClase[nivelClase].actividades[dia]) {
						participacionesPorClase[nivelClase].actividades[dia][id_actividad].sort((a, b) => { return (a.nombre < b.nombre) ? -1 : (a.nombre > b.nombre) ? 1 : 0; });
					}
				}
			}
			this.participacionesPorClase = participacionesPorClase;
		},
		periodoTexto(periodo) {
			return utils.convertirPeriodo(periodo);
		},
	}
}
</script>






